import type { JSX } from 'react';

import { stripHtmlTags } from '@change-corgi/core/html';
import { LocalizeNumber, TranslatePlural } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconGroup } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import type { User } from 'src/app/pages/movement/shared/types';

import { UserCard } from '../user/UserCard';

export type Props = {
	ask: string;
	totalSignatureCount: number;
	description: string;
	user: User;
};

export function MovementPetitionInfo({ ask, totalSignatureCount, description, user }: Props): JSX.Element | null {
	return (
		<Flex sx={{ flexDirection: 'column' }} m={8}>
			<Box sx={{ height: 150 }}>
				<Heading size="h4" as="h4" breakWord lineClamp={2}>
					{ask}
				</Heading>
				<Text breakWord lineClamp={4}>
					{stripHtmlTags(description)}
				</Text>
			</Box>
			<Flex
				sx={{
					flexDirection: 'row',
					alignItems: 'center',
					alignSelf: 'bottom',
					justifyContent: 'space-between',
					gap: 8,
				}}
			>
				<UserCard user={user} sx={{ flex: 1 }} />
				<Flex sx={{ alignItems: 'center' }}>
					<Icon icon={iconGroup} color="neutral-grey600" mr={8} />
					<Flex>
						{/* FIXME the count should be part of the i18n phrase */}
						<Text size="caption" mr={4}>
							<LocalizeNumber value={totalSignatureCount} />
						</Text>
						<Text size="caption">
							<TranslatePlural
								value="corgi.movement.show.heading.total_supporters_count_label"
								count={totalSignatureCount}
							/>
						</Text>
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
}
